import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { productService } from "./productService";


// Get All Product
export const getAllProduct = createAsyncThunk("get/product", async (thunkAPI) => {
    try {
        return await productService.getAllProduct()
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

// Get Single Product
export const getProduct = createAsyncThunk("get/product/id", async (productId, thunkAPI) => {
    try {
        return await productService.getProduct(productId)
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})


const initialState = {
    products: [],
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
}

export const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Get All Product
            .addCase(getAllProduct.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllProduct.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.isSuccess = true
                state.products = action.payload
            })
            .addCase(getAllProduct.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.error
            })
            
            // Get Single Product
            .addCase(getProduct.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getProduct.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.isSuccess = true
                state.products = action.payload
            })
            .addCase(getProduct.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.error
            })
            
    }
})

export default productSlice.reducer
